import { inject, observer } from "mobx-react";
import * as React from "react";
import { FullScreen } from "../General/FullScreen";
import { Screenfull } from "../Screenfull";
import { DialogStore } from "../Stores/DialogStore";
import { Button } from "./Button";
import { IButtonProps } from "./IButtonProps";
import { getDeepLinkReaderUrl } from "../Utilities";

interface IShareButtonProperties extends IButtonProps {
    fullScreen?: FullScreen;
    docId: string;
	fileName: string;
	originalFilename: string;
	extension: string;
    isDeleted: boolean;
    docLanguage: string;
}

@inject("fullScreen")
@observer
export class ShareButtonReader extends React.Component<IShareButtonProperties, {}> {

    getDeepLink = () => {
        if (this.props.fullScreen && Screenfull.element) {
            this.props.fullScreen.toggleFullScreen();
        }
		DialogStore.showDeepLink(window.location.origin + "/#" + getDeepLinkReaderUrl(this.props.docId, this.props.docLanguage, this.props.fileName, this.props.extension));
    }

    render() {
        return <Button {...this.props} onClick={this.getDeepLink}>
            <i>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                    <path d="M25,20a5,5,0,0,0-4.31,2.51L12,20.57a5,5,0,0,0-.63-2l6.53-7A5,5,0,0,0,20,12a5.06,5.06,0,1,0-4.33-2.54l-6.53,7A5,5,0,0,0,7,16a5,5,0,1,0,4.31,7.49L20,25.43A5,5,0,1,0,25,20Z" />
                </svg>
            </i>
        </Button>;
    }
}